// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Nexus View — canvas layout (nexus-ui-mock/nexsus.png) */

.nexus-view-status {
  margin: 0 0 8px;
  padding: 0 4px;
  font-size: 13px;
  color: var(--c-text-muted, #64748b);
}

.nexus-view-status--warn {
  color: var(--c-warning, #b45309);
}

.nexus-view-body {
  padding: 0 !important;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
}

.nexus-view-shell {
  position: relative;
  flex: 1 1;
  min-height: calc(100vh - var(--layout-logo-block-height, 80px));
  display: flex;
  flex-direction: column;
  background: var(--ui-surface-subtle);
}

.nexus-view-shell--fullscreen {
  min-height: 100vh;
  background: var(--ui-surface-subtle);
}

.nexus-zoom-toolbar {
  position: absolute;
  top: 12px;
  right: 16px;
  z-index: 20;
  pointer-events: auto;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  background: var(--c-white);
  border: 1px solid var(--border);
  border-radius: var(--border-radius);
  box-shadow: var(--ui-shadow-sm);
}

.nexus-zoom-label {
  font-size: 12px;
  font-weight: 600;
  min-width: 36px;
  color: var(--c-black);
}

.nexus-zoom-slider {
  width: 88px;
  accent-color: var(--c-teal-active);
}

.nexus-zoom-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: 1px solid var(--border);
  border-radius: var(--border-radius-sm);
  background: var(--c-white);
  color: var(--text2);
  cursor: pointer;
}

.nexus-zoom-btn:hover {
  background: var(--surface-hover-tint);
}

.nexus-flow-host {
  flex: 1 1;
  min-height: 0;
  width: 100%;
  position: relative;
  touch-action: none;
}

.nexus-react-flow {
  width: 100%;
  height: 100%;
  background: transparent;
}

.nexus-react-flow .react-flow__pane {
  cursor: grab;
}

.nexus-react-flow .react-flow__pane:active {
  cursor: grabbing;
}

.nexus-react-flow .react-flow__edge-path {
  stroke: var(--c-teal-active);
  stroke-width: 2;
}

.nexus-react-flow .react-flow__connectionline {
  stroke: var(--c-teal-active);
}

.nexus-flow-node {
  position: relative;
  cursor: grab;
}

.nexus-react-flow .react-flow__node.dragging .nexus-flow-node {
  cursor: grabbing;
}

.nexus-flow-node.nopan {
  pointer-events: auto;
}

.nexus-react-flow .react-flow__node {
  pointer-events: none;
}

.nexus-react-flow .react-flow__node .nopan {
  pointer-events: auto;
}

.nexus-flow-node--source .nexus-source-card,
.nexus-flow-node--readout .nexus-readout-card,
.nexus-flow-node--competitors .nexus-competitors-card {
  width: 100%;
}

.nexus-flow-handle {
  width: 10px;
  height: 10px;
  border: 2px solid var(--c-white);
  background: var(--c-teal-active);
  opacity: 1;
}

.nexus-flow-handle--target {
  background: var(--c-neon);
  border-color: var(--c-black);
}

.nexus-flow-handle--readout-top,
.nexus-flow-handle--readout-bottom {
  opacity: 0;
  pointer-events: none;
}

.nexus-flow-minimap {
  margin: 12px;
  border: 1px solid var(--border);
  border-radius: var(--border-radius);
  box-shadow: var(--ui-shadow-sm);
  overflow: hidden;
}

.nexus-flow-minimap .react-flow__minimap-mask {
  fill: color-mix(in srgb, var(--c-white) 72%, transparent);
}

.nexus-flow-minimap .react-flow__minimap-node {
  fill: color-mix(in srgb, var(--c-teal-active) 45%, transparent);
  stroke: var(--c-teal-active);
  stroke-width: 1;
}

/* Shared card chrome */
.nexus-source-card,
.nexus-readout-card,
.nexus-competitors-card {
  background: var(--c-white);
  border: 1px solid var(--border);
  border-radius: var(--border-radius-lg);
  box-shadow: var(--shadow-panel);
}

.nexus-source-card {
  width: 100%;
  max-width: 340px;
  padding: 14px 16px 12px;
}

.nexus-source-card__head,
.nexus-readout-card__head,
.nexus-competitors-card__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 10px;
}

.nexus-source-card__title-row,
.nexus-readout-card__title-row,
.nexus-competitors-card__title-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.nexus-source-card__title-row h3,
.nexus-competitors-card__title-row h3 {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  color: var(--c-black);
}

.nexus-source-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
}

.nexus-source-icon--blue {
  background: var(--bg-blue-soft);
  color: var(--c-blue-1);
}

.nexus-source-icon--green {
  background: var(--bg-green-soft);
  color: var(--c-green);
}

.nexus-source-icon--purple {
  background: var(--bg-purple-soft);
  color: var(--c-purple-1);
}

.nexus-source-icon--orange {
  background: var(--bg-orange-soft);
  color: var(--c-orange);
}

.nexus-source-icon--linkedin {
  background: color-mix(in srgb, var(--c-blue-1) 12%, transparent);
  color: var(--c-blue-1);
}

.nexus-source-icon--meta {
  background: color-mix(in srgb, var(--c-blue-2) 14%, transparent);
  color: var(--c-blue-2);
}

.nexus-source-icon--google {
  background: color-mix(in srgb, #1a7f4b 12%, transparent);
  color: #1a7f4b;
}

.nexus-source-card--google-ads {
  border-top: 3px solid #1a7f4b;
}

.nexus-count-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 22px;
  padding: 0 6px;
  border-radius: var(--border-radius-pill);
  background: var(--bar-track-bg);
  font-size: var(--fs-sm);
  font-weight: 600;
  color: var(--text2);
}

.nexus-card-menu {
  border: none;
  background: transparent;
  color: var(--text3);
  cursor: pointer;
  padding: 2px;
  border-radius: 4px;
}

.nexus-card-menu:hover {
  background: var(--surface-hover-tint);
  color: var(--text2);
}

.nexus-source-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.nexus-source-list li {
  display: flex;
  gap: 8px;
  align-items: flex-start;
}

.nexus-source-list__link {
  display: flex;
  gap: 8px;
  align-items: flex-start;
  flex: 1 1;
  min-width: 0;
  color: inherit;
  text-decoration: none;
}

.nexus-source-list__link:hover .nexus-source-list__company {
  color: var(--c-teal-active, #0d9488);
}

.nexus-list-icon {
  flex-shrink: 0;
  margin-top: 2px;
  color: var(--text3);
}

.nexus-source-list__body {
  flex: 1 1;
  min-width: 0;
}

.nexus-source-list__row {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  align-items: center;
}

.nexus-source-list__company {
  font-size: 13px;
  font-weight: 600;
  color: var(--c-black);
}

.nexus-source-list__time {
  font-size: 11px;
  color: var(--text3);
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.nexus-source-list__meta {
  font-size: 12px;
  color: var(--text2);
  margin-top: 2px;
}

.nexus-source-list__meta--grouped {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.nexus-source-list__detail--count {
  font-weight: 600;
  color: var(--c-black);
}

.nexus-source-list__meta-sub {
  font-size: 11px;
  line-height: 1.35;
  color: var(--text3);
}

.nexus-source-list__dot {
  margin: 0 4px;
}

.nexus-live-dot {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--c-green);
}

/* News card */
.nexus-news-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.nexus-news-list__head {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  align-items: flex-start;
}

.nexus-news-list__title {
  font-size: 13px;
  font-weight: 600;
  color: var(--c-black);
  line-height: 1.35;
}

.nexus-news-list__summary {
  margin: 6px 0 0;
  font-size: 12px;
  line-height: 1.45;
  color: var(--text2);
}

/* Ads cards — LinkedIn & Meta */
.nexus-ads-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.nexus-ads-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.nexus-platform-badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 6px;
  border-radius: var(--border-radius-sm);
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}

.nexus-platform-badge--linkedin {
  background: color-mix(in srgb, var(--c-blue-1) 12%, transparent);
  color: var(--c-blue-1);
}

.nexus-platform-badge--meta {
  background: color-mix(in srgb, var(--c-blue-2) 14%, transparent);
  color: var(--c-blue-1);
}

.nexus-platform-badge--google {
  background: color-mix(in srgb, #1a7f4b 12%, transparent);
  color: #1a7f4b;
}

.nexus-ad-tile__meta-row {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;
}

.nexus-ad-tile__company {
  font-size: 10px;
  font-weight: 600;
  color: var(--text2);
}

.nexus-ad-tile {
  border: 1px solid var(--border);
  border-radius: var(--border-radius);
  overflow: hidden;
  background: var(--ui-surface-muted);
}

.nexus-ad-tile__image {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  min-height: 96px;
  max-height: 132px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.nexus-ad-tile__image--remote {
  background-color: var(--c-gray-1, #e2e8f0);
  overflow: hidden;
}

.nexus-ad-tile__image--remote img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center top;
  display: block;
}

.nexus-ad-tile__media-badge {
  position: absolute;
  right: 6px;
  bottom: 6px;
  padding: 2px 6px;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: var(--c-white);
  background: color-mix(in srgb, var(--c-black) 55%, transparent);
  border-radius: 3px;
  pointer-events: none;
}

.nexus-ad-tile__image--forest {
  background-image: linear-gradient(
    135deg,
    var(--c-teal-3) 0%,
    var(--c-aqua-mass) 50%,
    var(--c-teal-active) 100%
  );
}

.nexus-ad-tile__image--mountain {
  background-image: linear-gradient(
    160deg,
    var(--c-blue-2) 0%,
    var(--c-blue-4) 40%,
    var(--c-blue-1) 100%
  );
}

.nexus-ad-tile__image--linkedin {
  background-image: linear-gradient(
    135deg,
    var(--c-blue-1) 0%,
    var(--c-blue-3) 55%,
    var(--c-blue-2) 100%
  );
}

.nexus-ad-tile__image--linkedin-alt {
  background-image: linear-gradient(
    160deg,
    var(--c-blue-4) 0%,
    var(--c-blue-2) 50%,
    var(--c-blue-1) 100%
  );
}

.nexus-ad-tile__image--meta {
  background-image: linear-gradient(
    135deg,
    var(--c-blue-2) 0%,
    var(--c-cyan-2) 50%,
    var(--c-blue-1) 100%
  );
}

.nexus-ad-tile__image--meta-alt {
  background-image: linear-gradient(
    160deg,
    var(--c-cyan-3) 0%,
    var(--c-blue-3) 45%,
    var(--c-blue-1) 100%
  );
}

.nexus-ad-tile__image--google {
  background-image: linear-gradient(
    135deg,
    #1a7f4b 0%,
    #34a853 50%,
    #0d652d 100%
  );
}

.nexus-ad-tile__image--google-alt {
  background-image: linear-gradient(
    160deg,
    #34a853 0%,
    #1a7f4b 50%,
    #0d652d 100%
  );
}

.nexus-ad-tile__body {
  padding: 8px;
}

.nexus-ad-tile__title {
  margin: 0 0 4px;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.3;
  color: var(--c-black);
}

.nexus-ad-tile__sub,
.nexus-ad-tile__time {
  margin: 0;
  font-size: 10px;
  color: var(--text3);
}

.nexus-ad-tile__time {
  margin-top: 2px;
}

.nexus-ad-tile__cta {
  margin-top: 6px;
  padding: 4px 8px;
  font-size: 10px;
  font-weight: 600;
  border: 1px solid var(--border);
  border-radius: 4px;
  background: var(--c-white);
  cursor: pointer;
}

/* AI readout center card */
.nexus-readout-card {
  width: 100%;
  max-width: 400px;
  padding: 18px 20px 16px;
  border: 1px solid var(--border);
  border-top: 4px solid var(--c-neon);
}

.nexus-readout-card__head h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
}

.nexus-readout-card__ai-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: var(--c-neon);
  color: var(--c-black);
}

.nexus-readout-card__status {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  margin-bottom: 14px;
  border-radius: var(--border-radius);
  background: var(--bg-green-soft);
  font-size: var(--fs-sm);
  color: var(--c-blue-1);
  font-weight: 500;
}

.nexus-readout-card__bullets {
  margin: 0 0 16px;
  padding-left: 18px;
  font-size: 13px;
  line-height: 1.55;
  color: var(--c-black);
}

.nexus-readout-card__bullets li {
  margin-bottom: 8px;
}

.nexus-readout-card__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.nexus-readout-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  font-size: 12px;
  font-weight: 600;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--c-white);
  color: var(--c-black);
  cursor: pointer;
}

.nexus-readout-btn:hover {
  background: var(--surface-hover-tint);
  border-color: var(--border-hover);
}

/* Key competitors */
.nexus-competitors-card {
  padding: 12px 14px;
  width: 100%;
}

.nexus-competitors-card__title-row h3 {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
}

.nexus-competitors-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.nexus-competitor-chip {
  padding: 6px 12px;
  border-radius: var(--border-radius-pill);
  background: var(--bg-teal-soft);
  border: 1px solid color-mix(in srgb, var(--c-teal-active) 25%, transparent);
  font-size: var(--fs-sm);
  font-weight: 500;
  color: var(--c-teal-active);
}

@media (max-width: 1100px) {
  .nexus-ads-grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/nexus/NexusView.css"],"names":[],"mappings":"AAAA,0DAA0D;;AAE1D;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,+DAA+D;EAC/D,aAAa;EACb,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,0BAA0B;EAC1B,+BAA+B;EAC/B,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,sCAAsC;EACtC,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,gCAAgC;EAChC,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;;EAEE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,+BAA+B;EAC/B,mCAAmC;EACnC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,+DAA+D;EAC/D,4BAA4B;EAC5B,eAAe;AACjB;;AAEA,uBAAuB;AACvB;;;EAGE,0BAA0B;EAC1B,+BAA+B;EAC/B,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;;EAGE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,QAAQ;EACR,mBAAmB;AACrB;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;;EAEE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA;EACE,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;EACE,gEAAgE;EAChE,sBAAsB;AACxB;;AAEA;EACE,gEAAgE;EAChE,sBAAsB;AACxB;;AAEA;EACE,wDAAwD;EACxD,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,wCAAwC;EACxC,+BAA+B;EAC/B,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,SAAO;EACP,YAAY;EACZ,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA,cAAc;AACd;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,sCAAsC;EACtC,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,gEAAgE;EAChE,sBAAsB;AACxB;;AAEA;EACE,gEAAgE;EAChE,sBAAsB;AACxB;;AAEA;EACE,wDAAwD;EACxD,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,mCAAmC;EACnC,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,+DAA+D;EAC/D,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE;;;;;GAKC;AACH;;AAEA;EACE;;;;;GAKC;AACH;;AAEA;EACE;;;;;GAKC;AACH;;AAEA;EACE;;;;;GAKC;AACH;;AAEA;EACE;;;;;GAKC;AACH;;AAEA;EACE;;;;;GAKC;AACH;;AAEA;EACE;;;;;GAKC;AACH;;AAEA;EACE;;;;;GAKC;AACH;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;EAEE,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,+BAA+B;EAC/B,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,mCAAmC;EACnC,gCAAgC;EAChC,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,0BAA0B;EAC1B,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,iCAAiC;AACnC;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,wCAAwC;EACxC,+BAA+B;EAC/B,2EAA2E;EAC3E,uBAAuB;EACvB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* Nexus View — canvas layout (nexus-ui-mock/nexsus.png) */\n\n.nexus-view-status {\n  margin: 0 0 8px;\n  padding: 0 4px;\n  font-size: 13px;\n  color: var(--c-text-muted, #64748b);\n}\n\n.nexus-view-status--warn {\n  color: var(--c-warning, #b45309);\n}\n\n.nexus-view-body {\n  padding: 0 !important;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n}\n\n.nexus-view-shell {\n  position: relative;\n  flex: 1;\n  min-height: calc(100vh - var(--layout-logo-block-height, 80px));\n  display: flex;\n  flex-direction: column;\n  background: var(--ui-surface-subtle);\n}\n\n.nexus-view-shell--fullscreen {\n  min-height: 100vh;\n  background: var(--ui-surface-subtle);\n}\n\n.nexus-zoom-toolbar {\n  position: absolute;\n  top: 12px;\n  right: 16px;\n  z-index: 20;\n  pointer-events: auto;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 10px;\n  background: var(--c-white);\n  border: 1px solid var(--border);\n  border-radius: var(--border-radius);\n  box-shadow: var(--ui-shadow-sm);\n}\n\n.nexus-zoom-label {\n  font-size: 12px;\n  font-weight: 600;\n  min-width: 36px;\n  color: var(--c-black);\n}\n\n.nexus-zoom-slider {\n  width: 88px;\n  accent-color: var(--c-teal-active);\n}\n\n.nexus-zoom-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border: 1px solid var(--border);\n  border-radius: var(--border-radius-sm);\n  background: var(--c-white);\n  color: var(--text2);\n  cursor: pointer;\n}\n\n.nexus-zoom-btn:hover {\n  background: var(--surface-hover-tint);\n}\n\n.nexus-flow-host {\n  flex: 1;\n  min-height: 0;\n  width: 100%;\n  position: relative;\n  touch-action: none;\n}\n\n.nexus-react-flow {\n  width: 100%;\n  height: 100%;\n  background: transparent;\n}\n\n.nexus-react-flow .react-flow__pane {\n  cursor: grab;\n}\n\n.nexus-react-flow .react-flow__pane:active {\n  cursor: grabbing;\n}\n\n.nexus-react-flow .react-flow__edge-path {\n  stroke: var(--c-teal-active);\n  stroke-width: 2;\n}\n\n.nexus-react-flow .react-flow__connectionline {\n  stroke: var(--c-teal-active);\n}\n\n.nexus-flow-node {\n  position: relative;\n  cursor: grab;\n}\n\n.nexus-react-flow .react-flow__node.dragging .nexus-flow-node {\n  cursor: grabbing;\n}\n\n.nexus-flow-node.nopan {\n  pointer-events: auto;\n}\n\n.nexus-react-flow .react-flow__node {\n  pointer-events: none;\n}\n\n.nexus-react-flow .react-flow__node .nopan {\n  pointer-events: auto;\n}\n\n.nexus-flow-node--source .nexus-source-card,\n.nexus-flow-node--readout .nexus-readout-card,\n.nexus-flow-node--competitors .nexus-competitors-card {\n  width: 100%;\n}\n\n.nexus-flow-handle {\n  width: 10px;\n  height: 10px;\n  border: 2px solid var(--c-white);\n  background: var(--c-teal-active);\n  opacity: 1;\n}\n\n.nexus-flow-handle--target {\n  background: var(--c-neon);\n  border-color: var(--c-black);\n}\n\n.nexus-flow-handle--readout-top,\n.nexus-flow-handle--readout-bottom {\n  opacity: 0;\n  pointer-events: none;\n}\n\n.nexus-flow-minimap {\n  margin: 12px;\n  border: 1px solid var(--border);\n  border-radius: var(--border-radius);\n  box-shadow: var(--ui-shadow-sm);\n  overflow: hidden;\n}\n\n.nexus-flow-minimap .react-flow__minimap-mask {\n  fill: color-mix(in srgb, var(--c-white) 72%, transparent);\n}\n\n.nexus-flow-minimap .react-flow__minimap-node {\n  fill: color-mix(in srgb, var(--c-teal-active) 45%, transparent);\n  stroke: var(--c-teal-active);\n  stroke-width: 1;\n}\n\n/* Shared card chrome */\n.nexus-source-card,\n.nexus-readout-card,\n.nexus-competitors-card {\n  background: var(--c-white);\n  border: 1px solid var(--border);\n  border-radius: var(--border-radius-lg);\n  box-shadow: var(--shadow-panel);\n}\n\n.nexus-source-card {\n  width: 100%;\n  max-width: 340px;\n  padding: 14px 16px 12px;\n}\n\n.nexus-source-card__head,\n.nexus-readout-card__head,\n.nexus-competitors-card__head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n.nexus-source-card__title-row,\n.nexus-readout-card__title-row,\n.nexus-competitors-card__title-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.nexus-source-card__title-row h3,\n.nexus-competitors-card__title-row h3 {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 700;\n  color: var(--c-black);\n}\n\n.nexus-source-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n}\n\n.nexus-source-icon--blue {\n  background: var(--bg-blue-soft);\n  color: var(--c-blue-1);\n}\n\n.nexus-source-icon--green {\n  background: var(--bg-green-soft);\n  color: var(--c-green);\n}\n\n.nexus-source-icon--purple {\n  background: var(--bg-purple-soft);\n  color: var(--c-purple-1);\n}\n\n.nexus-source-icon--orange {\n  background: var(--bg-orange-soft);\n  color: var(--c-orange);\n}\n\n.nexus-source-icon--linkedin {\n  background: color-mix(in srgb, var(--c-blue-1) 12%, transparent);\n  color: var(--c-blue-1);\n}\n\n.nexus-source-icon--meta {\n  background: color-mix(in srgb, var(--c-blue-2) 14%, transparent);\n  color: var(--c-blue-2);\n}\n\n.nexus-source-icon--google {\n  background: color-mix(in srgb, #1a7f4b 12%, transparent);\n  color: #1a7f4b;\n}\n\n.nexus-source-card--google-ads {\n  border-top: 3px solid #1a7f4b;\n}\n\n.nexus-count-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 22px;\n  height: 22px;\n  padding: 0 6px;\n  border-radius: var(--border-radius-pill);\n  background: var(--bar-track-bg);\n  font-size: var(--fs-sm);\n  font-weight: 600;\n  color: var(--text2);\n}\n\n.nexus-card-menu {\n  border: none;\n  background: transparent;\n  color: var(--text3);\n  cursor: pointer;\n  padding: 2px;\n  border-radius: 4px;\n}\n\n.nexus-card-menu:hover {\n  background: var(--surface-hover-tint);\n  color: var(--text2);\n}\n\n.nexus-source-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.nexus-source-list li {\n  display: flex;\n  gap: 8px;\n  align-items: flex-start;\n}\n\n.nexus-source-list__link {\n  display: flex;\n  gap: 8px;\n  align-items: flex-start;\n  flex: 1;\n  min-width: 0;\n  color: inherit;\n  text-decoration: none;\n}\n\n.nexus-source-list__link:hover .nexus-source-list__company {\n  color: var(--c-teal-active, #0d9488);\n}\n\n.nexus-list-icon {\n  flex-shrink: 0;\n  margin-top: 2px;\n  color: var(--text3);\n}\n\n.nexus-source-list__body {\n  flex: 1;\n  min-width: 0;\n}\n\n.nexus-source-list__row {\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n  align-items: center;\n}\n\n.nexus-source-list__company {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--c-black);\n}\n\n.nexus-source-list__time {\n  font-size: 11px;\n  color: var(--text3);\n  white-space: nowrap;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.nexus-source-list__meta {\n  font-size: 12px;\n  color: var(--text2);\n  margin-top: 2px;\n}\n\n.nexus-source-list__meta--grouped {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.nexus-source-list__detail--count {\n  font-weight: 600;\n  color: var(--c-black);\n}\n\n.nexus-source-list__meta-sub {\n  font-size: 11px;\n  line-height: 1.35;\n  color: var(--text3);\n}\n\n.nexus-source-list__dot {\n  margin: 0 4px;\n}\n\n.nexus-live-dot {\n  display: inline-block;\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: var(--c-green);\n}\n\n/* News card */\n.nexus-news-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.nexus-news-list__head {\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n  align-items: flex-start;\n}\n\n.nexus-news-list__title {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--c-black);\n  line-height: 1.35;\n}\n\n.nexus-news-list__summary {\n  margin: 6px 0 0;\n  font-size: 12px;\n  line-height: 1.45;\n  color: var(--text2);\n}\n\n/* Ads cards — LinkedIn & Meta */\n.nexus-ads-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.nexus-ads-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n}\n\n.nexus-platform-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 6px;\n  border-radius: var(--border-radius-sm);\n  font-size: 9px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n}\n\n.nexus-platform-badge--linkedin {\n  background: color-mix(in srgb, var(--c-blue-1) 12%, transparent);\n  color: var(--c-blue-1);\n}\n\n.nexus-platform-badge--meta {\n  background: color-mix(in srgb, var(--c-blue-2) 14%, transparent);\n  color: var(--c-blue-1);\n}\n\n.nexus-platform-badge--google {\n  background: color-mix(in srgb, #1a7f4b 12%, transparent);\n  color: #1a7f4b;\n}\n\n.nexus-ad-tile__meta-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 4px;\n}\n\n.nexus-ad-tile__company {\n  font-size: 10px;\n  font-weight: 600;\n  color: var(--text2);\n}\n\n.nexus-ad-tile {\n  border: 1px solid var(--border);\n  border-radius: var(--border-radius);\n  overflow: hidden;\n  background: var(--ui-surface-muted);\n}\n\n.nexus-ad-tile__image {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 16 / 9;\n  min-height: 96px;\n  max-height: 132px;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n}\n\n.nexus-ad-tile__image--remote {\n  background-color: var(--c-gray-1, #e2e8f0);\n  overflow: hidden;\n}\n\n.nexus-ad-tile__image--remote img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center top;\n  display: block;\n}\n\n.nexus-ad-tile__media-badge {\n  position: absolute;\n  right: 6px;\n  bottom: 6px;\n  padding: 2px 6px;\n  font-size: 9px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  color: var(--c-white);\n  background: color-mix(in srgb, var(--c-black) 55%, transparent);\n  border-radius: 3px;\n  pointer-events: none;\n}\n\n.nexus-ad-tile__image--forest {\n  background-image: linear-gradient(\n    135deg,\n    var(--c-teal-3) 0%,\n    var(--c-aqua-mass) 50%,\n    var(--c-teal-active) 100%\n  );\n}\n\n.nexus-ad-tile__image--mountain {\n  background-image: linear-gradient(\n    160deg,\n    var(--c-blue-2) 0%,\n    var(--c-blue-4) 40%,\n    var(--c-blue-1) 100%\n  );\n}\n\n.nexus-ad-tile__image--linkedin {\n  background-image: linear-gradient(\n    135deg,\n    var(--c-blue-1) 0%,\n    var(--c-blue-3) 55%,\n    var(--c-blue-2) 100%\n  );\n}\n\n.nexus-ad-tile__image--linkedin-alt {\n  background-image: linear-gradient(\n    160deg,\n    var(--c-blue-4) 0%,\n    var(--c-blue-2) 50%,\n    var(--c-blue-1) 100%\n  );\n}\n\n.nexus-ad-tile__image--meta {\n  background-image: linear-gradient(\n    135deg,\n    var(--c-blue-2) 0%,\n    var(--c-cyan-2) 50%,\n    var(--c-blue-1) 100%\n  );\n}\n\n.nexus-ad-tile__image--meta-alt {\n  background-image: linear-gradient(\n    160deg,\n    var(--c-cyan-3) 0%,\n    var(--c-blue-3) 45%,\n    var(--c-blue-1) 100%\n  );\n}\n\n.nexus-ad-tile__image--google {\n  background-image: linear-gradient(\n    135deg,\n    #1a7f4b 0%,\n    #34a853 50%,\n    #0d652d 100%\n  );\n}\n\n.nexus-ad-tile__image--google-alt {\n  background-image: linear-gradient(\n    160deg,\n    #34a853 0%,\n    #1a7f4b 50%,\n    #0d652d 100%\n  );\n}\n\n.nexus-ad-tile__body {\n  padding: 8px;\n}\n\n.nexus-ad-tile__title {\n  margin: 0 0 4px;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1.3;\n  color: var(--c-black);\n}\n\n.nexus-ad-tile__sub,\n.nexus-ad-tile__time {\n  margin: 0;\n  font-size: 10px;\n  color: var(--text3);\n}\n\n.nexus-ad-tile__time {\n  margin-top: 2px;\n}\n\n.nexus-ad-tile__cta {\n  margin-top: 6px;\n  padding: 4px 8px;\n  font-size: 10px;\n  font-weight: 600;\n  border: 1px solid var(--border);\n  border-radius: 4px;\n  background: var(--c-white);\n  cursor: pointer;\n}\n\n/* AI readout center card */\n.nexus-readout-card {\n  width: 100%;\n  max-width: 400px;\n  padding: 18px 20px 16px;\n  border: 1px solid var(--border);\n  border-top: 4px solid var(--c-neon);\n}\n\n.nexus-readout-card__head h2 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 700;\n}\n\n.nexus-readout-card__ai-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  background: var(--c-neon);\n  color: var(--c-black);\n}\n\n.nexus-readout-card__status {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 10px;\n  margin-bottom: 14px;\n  border-radius: var(--border-radius);\n  background: var(--bg-green-soft);\n  font-size: var(--fs-sm);\n  color: var(--c-blue-1);\n  font-weight: 500;\n}\n\n.nexus-readout-card__bullets {\n  margin: 0 0 16px;\n  padding-left: 18px;\n  font-size: 13px;\n  line-height: 1.55;\n  color: var(--c-black);\n}\n\n.nexus-readout-card__bullets li {\n  margin-bottom: 8px;\n}\n\n.nexus-readout-card__actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.nexus-readout-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 12px;\n  font-size: 12px;\n  font-weight: 600;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  background: var(--c-white);\n  color: var(--c-black);\n  cursor: pointer;\n}\n\n.nexus-readout-btn:hover {\n  background: var(--surface-hover-tint);\n  border-color: var(--border-hover);\n}\n\n/* Key competitors */\n.nexus-competitors-card {\n  padding: 12px 14px;\n  width: 100%;\n}\n\n.nexus-competitors-card__title-row h3 {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.nexus-competitors-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.nexus-competitor-chip {\n  padding: 6px 12px;\n  border-radius: var(--border-radius-pill);\n  background: var(--bg-teal-soft);\n  border: 1px solid color-mix(in srgb, var(--c-teal-active) 25%, transparent);\n  font-size: var(--fs-sm);\n  font-weight: 500;\n  color: var(--c-teal-active);\n}\n\n@media (max-width: 1100px) {\n  .nexus-ads-grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
